'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';
import { useMarketingConsent } from '@/lib/cookie-consent';

export { trackFbq } from '@/lib/marketing/pixel-client';

const ROUTE_EVENTS = {
  '/planes':     "fbq('track','ViewContent',{content_name:'planes',content_category:'pricing'});",
  '/planesbeta': "fbq('track','ViewContent',{content_name:'planesbeta',content_category:'pricing'});",
  '/login':      "fbq('track','Lead',{content_name:'login_page'});",
  '/suscripcion':"fbq('track','InitiateCheckout');",
};

export default function MetaPixel() {
  const pixelId = process.env.NEXT_PUBLIC_META_PIXEL_ID;
  const consentGranted = useMarketingConsent();
  const pathname = usePathname();

  if (!pixelId) return null;
  if (!consentGranted) return null;

  const routeEvent = pathname ? (ROUTE_EVENTS[pathname] || '') : '';

  return (
    <>
      {/* PERF (auditoría PageSpeed 2026-07-03): lazyOnload en vez de afterInteractive.
          fbevents.js + signals/config pesan ~250KB y competían por red/CPU con el
          LCP en mobile (4G lenta). PageView sigue disparando, solo unos cientos de
          ms más tarde — no afecta atribución de Ads (no es un evento real-time). */}
      <Script id="meta-pixel-init" strategy="lazyOnload">
        {`
          !function(f,b,e,v,n,t,s){
            if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${pixelId}');
          fbq('track', 'PageView');
          ${routeEvent}
        `}
      </Script>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
          alt=""
        />
      </noscript>
    </>
  );
}
